import axios from 'axios';

const RESOURCE_NAME = '/dashboard';

export default {

    getAddedStartupsCount(days, userType) {
        return axios.get(`${RESOURCE_NAME}/added-startups-count?days=${days}&user_type=${userType}`)
    },

    getStartupsWithActivityCount(days, userType) {
        return axios.get(`${RESOURCE_NAME}/startups-with-activity-count?days=${days}&user_type=${userType}`)
    },

    getStartupsAssociatedWithTrackersCount(days, userType) {
        return axios.get(`${RESOURCE_NAME}/startups-associated-with-trackers-count?days=${days}&user_type=${userType}`)
    },

    getMostActiveStartups(days, userType) {
        return axios.get(`${RESOURCE_NAME}/most-active-startups?days=${days}&user_type=${userType}`)
    },

    getStaleStartups(days, userType) {
        return axios.get(`${RESOURCE_NAME}/stale-startups?days=${days}&user_type=${userType}`)
    },

    getConductedSearchesCount(days, userType) {
        return axios.get(`${RESOURCE_NAME}/conducted-searches-count?days=${days}&user_type=${userType}`)
    },

    getSavedSearchesCount(days, userType) {
        return axios.get(`${RESOURCE_NAME}/saved-searches-count?days=${days}&user_type=${userType}`)
    },

    getSavedSearches(days, userType) {
        return axios.get(`${RESOURCE_NAME}/saved-searches?days=${days}&user_type=${userType}`)
    },

    getTrackersCount(days, userType) {
        return axios.get(`${RESOURCE_NAME}/trackers-count?days=${days}&user_type=${userType}`)
    },

    getTrackersWithActivityCount(days, userType) {
        return axios.get(`${RESOURCE_NAME}/trackers-with-activity-count?days=${days}&user_type=${userType}`)
    },

    getTrackersWithNoStartupsCount(days, userType) {
        return axios.get(`${RESOURCE_NAME}/trackers-with-no-startups-count?days=${days}&user_type=${userType}`)
    },

    getMostActiveTrackers(days, userType) {
        return axios.get(`${RESOURCE_NAME}/most-active-trackers?days=${days}&user_type=${userType}`)
    },

    getStaleTrackers(days, userType) {
        return axios.get(`${RESOURCE_NAME}/stale-trackers?days=${days}&user_type=${userType}`)
    },

    getUsersCount(days, userType) {
        return axios.get(`${RESOURCE_NAME}/users-count?days=${days}&user_type=${userType}`)
    },

    getMostActiveUses(days, userType) {
        return axios.get(`${RESOURCE_NAME}/most-active-users?days=${days}&user_type=${userType}`)
    },

    getLastVisitedStartups() {
        return axios.get(`${RESOURCE_NAME}/last-visited-startups`)
    },
}